import { h, Component } from 'preact';
import Logo from 'components/bolt/uarHeader/components/logo/logo';
import Nav from 'components/bolt/uarHeader/components/nav/nav';
import Socials from 'components/bolt/uarHeader/components/socials/socials';
import s from 'components/bolt/uarHeader/uarHeader.sss';

export default class UarHeader extends Component {
	render({ data }) {
		return (
			<header class={s.wrapper}>
				<Logo data={data} extraClass={s.logo} />
				<Nav data={data} extraClass={s.nav} />
				<Socials data={data} extraClass={s.socials} />
			</header>
		);
	}
}
